import React from "react";
import { connect } from "react-redux";
import styles from "./loader.module.scss";

const SpinnerOverlay = ({ visible }) => {
	const spinner = (
		<div className={`${styles.spinnerOverlay}`}>
			<div className={styles.spinner}></div>
		</div>
	);

	return visible ? spinner : null;
};

const mapStateToProps = state => ({
	visible: state.ui.isSpinnerOverlayVisible,
});

const spinnerOverLay = connect(mapStateToProps)(SpinnerOverlay);
export { spinnerOverLay as SpinnerOverlay };
